<framework-launch-button
  (topButtonLaunch)="contentImport()"
  (bottomButtonLaunch)="urlImport()"
  [topButtonDisabled]="disabled"
  [bottomButtonDisabled]="disabled"
  [collapsedWidth]="160"
  [expandedWidth]="200"
  [expandedHeight]="80"
  [(expanded)]="expanded"
>
  <div topButton>Import Content <mat-icon>launch</mat-icon></div>
  <div bottomButton>Import URL <mat-icon>publish</mat-icon></div>
</framework-launch-button>
